import React, { useEffect, useRef, useContext } from "react";
import { ThemeContext } from "../../contexts/ThemeContext";
import { LanguageContext } from "../../contexts/LanguageContext";
import {
  StyledHero,
  HeroContent,
  HeroTechElements,
  TechParticles,
  TechCircle,
  TechLine,
  TechDots,
} from "./styles";

const Hero = () => {
  const { theme } = useContext(ThemeContext);
  const { language, translations } = useContext(LanguageContext);
  const particlesRef = useRef(null);

  // Inicializar partículas quando o componente montar
  useEffect(() => {
    if (
      typeof window !== "undefined" &&
      window.particlesJS &&
      particlesRef.current
    ) {
      window.particlesJS("particles-js", {
        particles: {
          number: {
            value: 80,
            density: {
              enable: true,
              value_area: 800,
            },
          },
          color: {
            value: "#ff6b00",
          },
          shape: {
            type: "circle",
            stroke: {
              width: 0,
              color: "#000000",
            },
            polygon: {
              nb_sides: 5,
            },
          },
          opacity: {
            value: 0.5,
            random: false,
            anim: {
              enable: false,
              speed: 1,
              opacity_min: 0.1,
              sync: false,
            },
          },
          size: {
            value: 3,
            random: true,
            anim: {
              enable: false,
              speed: 40,
              size_min: 0.1,
              sync: false,
            },
          },
          line_linked: {
            enable: true,
            distance: 150,
            color: "#ff6b00",
            opacity: 0.4,
            width: 1,
          },
          move: {
            enable: true,
            speed: 2,
            direction: "none",
            random: false,
            straight: false,
            out_mode: "out",
            bounce: false,
            attract: {
              enable: false,
              rotateX: 600,
              rotateY: 1200,
            },
          },
        },
        interactivity: {
          detect_on: "canvas",
          events: {
            onhover: {
              enable: true,
              mode: "grab",
            },
            onclick: {
              enable: true,
              mode: "push",
            },
            resize: true,
          },
          modes: {
            grab: {
              distance: 140,
              line_linked: {
                opacity: 1,
              },
            },
            bubble: {
              distance: 400,
              size: 40,
              duration: 2,
              opacity: 8,
              speed: 3,
            },
            repulse: {
              distance: 200,
              duration: 0.4,
            },
            push: {
              particles_nb: 4,
            },
            remove: {
              particles_nb: 2,
            },
          },
        },
        retina_detect: true,
      });
    }
  }, []);

  return (
    <StyledHero id="inicio">
      <TechParticles id="particles-js" ref={particlesRef} />
      <div className="container">
        <HeroContent>
          <h1
            dangerouslySetInnerHTML={{
              __html: translations[language].heroTitle,
            }}
          />
          <p>{translations[language].heroSubtitle}</p>
          <a href="#contato" className="btn btn-primary">
            <i className="fab fa-whatsapp"></i>{" "}
            <span>{translations[language].talkToSpecialists}</span>
          </a>
        </HeroContent>
        <HeroTechElements>
          <TechCircle />
          <TechLine />
          <TechDots />
        </HeroTechElements>
      </div>
    </StyledHero>
  );
};

export default Hero;
